import SlidingBar from "@/ui/animations/SlidingBar"
import Typography from "@/ui/atoms/Typography"
import FlexContainer from "@/ui/structure/FlexContainer"
import { BreakpointValue } from "@/ui/types/layout"
import { Fragment, ReactNode } from "react"

export type DynamicTextBlock = {
  texts: string[]
}

export interface DynamicTextsProps {
  separator?: ReactNode
  blocks: DynamicTextBlock[]
  horizontalBreakpoint?: BreakpointValue
}

const DynamicTexts = ({
  separator,
  blocks,
  horizontalBreakpoint,
}: DynamicTextsProps) => {
  return (
    <SlidingBar>
      <FlexContainer
        horizontalBreakpoint={horizontalBreakpoint}
        className="justify-between items-center px-4 py-16"
      >
        {blocks.map((block, i) => (
          <Fragment key={i}>
            <Typography variant={["h3", "h2"]} weight={"bold"} className="px-2">
              {block.texts[0]}
            </Typography>
            {separator && i < blocks.length - 1 && (
              <div className="my-2 mx-8 min-w-[40px] w-[40px]">{separator}</div>
            )}
          </Fragment>
        ))}
      </FlexContainer>
    </SlidingBar>
  )
}

export default DynamicTexts
